/* Big Play Festival: the price card's UPI line <-> festival banner swap
   (snippets/cs-price.liquid, .cs-price__rot; the motion is in cs-price.css).

   myfrido.com's pattern ("SalePlateSlot", measured 21 Oct by Abra): both
   faces roll UP together, 700ms cubic-bezier(.4,0,.2,1). A small timer
   toggles .cs-roll-in / .cs-roll-out and CSS does the roll. Their dwell is
   uneven on purpose: the UPI row rests 2.5s, the plate stays for its whole
   4.44s video. One setTimeout per strip, nothing per frame.

   Loaded once per page, with defer, from snippets/cs-fest-pdp.liquid. Dawn's
   product-info.js replaces the card's HTML on every variant change, which
   throws away the strip we were driving; the MutationObserver below picks up
   the new one, and the old one's timer is dropped.

   The timer only runs while the sale is live (html.cs-fest-live), motion is
   allowed, the card is on-screen, the tab is visible, and nobody is hovering
   on it or has tabbed onto it. Off-screen or hidden also sets .is-paused,
   which stops the lamps' CSS loops. */
(function () {
  if (window.__csPriceRot) return;
  window.__csPriceRot = true;

  /* Ms from one roll's start to the next, Frido's numbers. The UPI row waits
     2.5s, plus the 0.7s it takes to roll in once it has rolled at all, so it
     always rests a full 2.5s (their code: 2500 + (rolled ? 700 : 0)). The
     banner stays 4.44s, Frido's plate length, so both burst rounds (420ms
     and 1900ms) play out before it leaves. */
  var UPI_MS = 2500, ROLL_MS = 700, FEST_MS = 4440;
  function dwell(s) {
    return s.cur === 0 ? UPI_MS + (s.rolled ? ROLL_MS : 0) : FEST_MS;
  }
  var root = document.documentElement;
  var strips = document.getElementsByClassName('cs-price__rot'); // live list
  var states = [];
  var reduce = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;
  var io = 'IntersectionObserver' in window
    ? new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          var s = e.target.__csRot;
          if (!s) return;
          s.seen = e.isIntersecting;
          update(s);
        });
      })
    : null;

  function canRun(s) {
    return root.classList.contains('cs-fest-live') &&
      !(reduce && reduce.matches) &&
      !document.hidden &&
      s.seen !== false &&
      !s.hover &&
      !s.focus;
  }

  // Start or stop one strip's timer. A running timer is left alone, so events
  // that change nothing (the IO's first report, window load) cannot stretch a
  // dwell; a stopped one restarts with a full dwell, so a face never leaves
  // the moment someone scrolls back to it.
  function update(s) {
    s.el.classList.toggle('is-paused', document.hidden || s.seen === false);
    if (!canRun(s)) {
      clearTimeout(s.timer);
      s.timer = 0;
    } else if (!s.timer) {
      s.timer = setTimeout(function () { roll(s); }, dwell(s));
    }
  }

  function show(s, next) {
    var out = s.items[s.cur], inn = s.items[next];
    out.classList.remove('cs-roll-in');
    out.classList.add('cs-roll-out');
    inn.classList.remove('cs-roll-out');
    inn.classList.add('cs-roll-in');
    if (inn.classList.contains('cs-price__fest')) greet(inn);
    s.cur = next;
    s.rolled = true;
    // The banner just rolled in: one round of bursts as it lands, one more
    // while it is up. Nothing fires if it has gone again or left the screen.
    if (inn.classList.contains('cs-price__fest')) {
      setTimeout(function () { if (s.cur === next && canRun(s)) crackers(inn); }, 420);
      setTimeout(function () { if (s.cur === next && canRun(s)) crackers(inn); }, 1900);
    }
  }

  /* Small bursts inside the banner, drawn exactly like the collection-page
     fireworks (cs-fest-crackers.liquid: spark trails faded with
     destination-out, slight gravity, Orange / Bright Amber / Lemon Lime),
     scaled down to a 50px strip and kept to its two ends so the words stay
     clear. One rAF loop per banner, only while sparks are alive. */
  var COLORS = ['#FAA730', '#FFCF29', '#CADB33'];
  function crackers(banner) {
    var cv = banner.querySelector('.cs-price__fest-fx');
    if (!cv || !cv.getContext) return;
    var W = cv.clientWidth, H = cv.clientHeight;
    if (!W || !H) return;
    var dpr = Math.min(window.devicePixelRatio || 1, 2);
    if (cv.width !== Math.round(W * dpr)) { cv.width = Math.round(W * dpr); cv.height = Math.round(H * dpr); }
    var g = cv.getContext('2d');
    g.setTransform(dpr, 0, 0, dpr, 0, 0);
    var st = cv.__fx || (cv.__fx = { P: [], run: false });
    // Bursts in the gutters only, sized off the text so they never land on a letter.
    var t = banner.querySelector('.cs-price__fest-title'), ch = banner.querySelector('.cs-price__fest-chip');
    var br = banner.getBoundingClientRect();
    var L = t ? Math.max(14, (t.getBoundingClientRect().left - br.left) / 2) : W * 0.06;
    var rEl = (ch && ch.offsetWidth) ? ch : t; // no ticket (greeting): mirror the title's gutter
    var R = rEl ? Math.min(W - 14, W - (br.right - rEl.getBoundingClientRect().right) / 2) : W * 0.94;
    var spots = [[L / W, 0.40], [R / W, 0.36], [R / W, 0.66], [L / W, 0.68]];
    spots.forEach(function (p, i) {
      setTimeout(function () { pop(st, W * p[0], H * p[1], COLORS[i % 3], H); start(); }, i * 150);
    });
    function start() {
      if (st.run) return;
      st.run = true;
      requestAnimationFrame(frame);
    }
    function frame() {
      g.globalCompositeOperation = 'destination-out';
      g.fillStyle = 'rgba(0,0,0,0.2)';
      g.fillRect(0, 0, W, H);
      g.globalCompositeOperation = 'source-over';
      var alive = 0;
      st.P.forEach(function (q) {
        if (q.life <= 0) return;
        q.px = q.x; q.py = q.y;
        q.vx *= 0.96; q.vy = q.vy * 0.96 + H / 1400;
        q.x += q.vx; q.y += q.vy; q.life -= q.decay;
        if (q.life <= 0) return;
        alive++;
        var tw = q.life < 0.35 ? (Math.random() < 0.5 ? 0.25 : 1) : 1;
        g.globalAlpha = Math.max(q.life, 0) * tw;
        g.strokeStyle = q.c; g.lineWidth = q.r; g.lineCap = 'round';
        g.beginPath(); g.moveTo(q.px, q.py); g.lineTo(q.x, q.y); g.stroke();
      });
      g.globalAlpha = 1;
      if (alive) requestAnimationFrame(frame);
      else { g.clearRect(0, 0, W, H); st.P.length = 0; st.run = false; }
    }
  }
  function pop(st, x, y, c, H) {
    var n = 28, sp0 = H / 17;
    for (var i = 0; i < n; i++) {
      var a = (i / n) * Math.PI * 2 + Math.random() * 0.2, sp = sp0 * (0.5 + Math.random() * 0.6);
      st.P.push({ x: x, y: y, px: x, py: y, vx: Math.cos(a) * sp, vy: Math.sin(a) * sp, life: 1,
                  decay: 0.026 + Math.random() * 0.018, r: 1.6 + Math.random() * 1.2,
                  c: Math.random() < 0.55 ? c : COLORS[(Math.random() * COLORS.length) | 0] });
    }
  }

  /* The chip's countdown to settings.fest_end. One 1s clock for the page,
     writing only while some strip is on-screen and the tab is visible. */
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function tick() {
    if (document.hidden || !root.classList.contains('cs-fest-sale')) return;
    for (var i = 0; i < states.length; i++) {
      var s = states[i];
      if (s.seen === false) continue;
      var f = s.items[1];
      var end = s.endAt || (s.endAt = Date.parse(f.getAttribute('data-cs-fest-end') || ''));
      var cd = s.cd || (s.cd = f.querySelector('[data-cs-rot-cd]'));
      if (!cd || !end) continue;
      var ms = end - Date.now();
      if (ms <= 0) { cd.textContent = 'Last few hours'; continue; }
      var x = Math.floor(ms / 1000), d = Math.floor(x / 86400);
      cd.textContent = (d ? d + 'd ' : '') + pad(Math.floor(x % 86400 / 3600)) + ':' + pad(Math.floor(x % 3600 / 60)) + ':' + pad(x % 60);
    }
  }

  /* After the sale (html.cs-fest-live without .cs-fest-sale) the banner is a
     greeting instead of a countdown. Owner, 3 Nov: "make it change as per days
     like lakshmi pujan etc, on random days let it say happy diwali". Dates are
     Diwali 2026 in IST; panchangs split Govardhan (9/10 Nov) and Bhai Dooj
     (10/11 Nov), so the 10th says Bhai Dooj and the 11th keeps it. The ticket
     is hidden (owner, 3 Nov: "greeting only, no ticket"); the banner still opens the Coupons sheet.
     ?greet_day=YYYY-MM-DD previews another day. */
  var GREET = {
    '2026-11-06': ['Happy', 'Dhanteras'],
    '2026-11-07': ['Happy', 'Choti Diwali'],
    '2026-11-08': ['Shubh', 'Lakshmi Pujan'],
    '2026-11-09': ['Happy', 'Govardhan Puja'],
    '2026-11-10': ['Happy', 'Bhai Dooj'],
    '2026-11-11': ['Happy', 'Bhai Dooj']
  };
  function greet(b) {
    if (root.classList.contains('cs-fest-sale')) return;
    var day = new Date(Date.now() + 330 * 60000).toISOString().slice(0, 10); // IST date
    var q = /[?&]greet_day=([0-9]{4}-[0-9]{2}-[0-9]{2})/.exec(location.search);
    if (q) day = q[1];
    var g = GREET[day] || ['Happy', 'Diwali'];
    if (b.__csGreet === day) return;
    b.__csGreet = day;
    var t = b.querySelector('.cs-price__fest-title'), ch = b.querySelector('.cs-price__fest-chip');
    if (t) t.innerHTML = g[0] + ' <b>' + g[1] + '</b>';
    if (ch) ch.style.display = 'none'; // owner, 3 Nov: greeting only, no ticket
    b.setAttribute('aria-label', g[0] + ' ' + g[1] + ' from Clapstore Toys. See offers and coupons');
  }

  function roll(s) {
    s.timer = 0; // this one has fired; update() books the next
    if (!s.el.isConnected) return forget(s);
    if (canRun(s)) show(s, 1 - s.cur);
    update(s);
  }

  function forget(s) {
    clearTimeout(s.timer);
    if (io) io.unobserve(s.el);
    var i = states.indexOf(s);
    if (i !== -1) states.splice(i, 1);
  }

  function watch(el) {
    var items = Array.prototype.slice.call(el.children, 0, 2);
    if (items.length < 2) return;
    var s = { el: el, items: items, cur: 0, timer: 0, rolled: false, seen: undefined, hover: false, focus: false };
    el.__csRot = s;
    states.push(s);

    // Mouse only: a tap leaves a phone "hovering" until the next tap.
    el.addEventListener('pointerenter', function (e) {
      if (e.pointerType === 'mouse') { s.hover = true; update(s); }
    });
    el.addEventListener('pointerleave', function (e) {
      if (e.pointerType === 'mouse') { s.hover = false; update(s); }
    });

    // Keyboard focus brings that face in and holds it. A tap also focuses the
    // button on Android, but that must not freeze the strip for good.
    el.addEventListener('focusin', function (e) {
      var kb = true;
      try { kb = e.target.matches(':focus-visible'); } catch (err) {}
      if (!kb) return;
      s.focus = true;
      var i = s.items.indexOf(e.target);
      if (i !== -1 && i !== s.cur) show(s, i);
      update(s);
    });
    el.addEventListener('focusout', function (e) {
      if (e.relatedTarget && el.contains(e.relatedTarget)) return;
      if (!s.focus) return;
      s.focus = false;
      update(s);
    });

    if (io) io.observe(el);
    update(s);
  }

  function scan() {
    var i;
    for (i = states.length - 1; i >= 0; i--) {
      if (!states[i].el.isConnected) forget(states[i]);
    }
    for (i = 0; i < strips.length; i++) {
      if (!strips[i].__csRot) watch(strips[i]);
    }
  }

  function all() {
    for (var i = 0; i < states.length; i++) update(states[i]);
  }

  document.addEventListener('visibilitychange', all);
  // cs-fest-pdp re-asserts html.cs-fest-live on load; catch it if it was late.
  window.addEventListener('load', all);
  if (reduce) {
    if (reduce.addEventListener) reduce.addEventListener('change', all);
    else if (reduce.addListener) reduce.addListener(all);
  }

  // Only element insertions can bring a new strip; text-only churn (countdown
  // clocks) is skipped without a scan.
  new MutationObserver(function (records) {
    for (var i = 0; i < records.length; i++) {
      var added = records[i].addedNodes;
      for (var j = 0; j < added.length; j++) {
        if (added[j].nodeType === 1) { scan(); return; }
      }
    }
  }).observe(document.body, { childList: true, subtree: true });

  scan();
  tick();
  setInterval(tick, 1000);
})();
